/**
 * @fileoverview German translations.
 * @package PlayItNow
 * @module apps/front/lib/i18n/locales/de
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

export const de = {
  login: {
    title: 'PlayItNow',
    subtitle: 'Melden Sie sich in Ihrem Admin-Bereich an',
    emailLabel: 'E-Mail oder Benutzername',
    emailPlaceholder: 'ihre@email.com oder Benutzername',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    submitButton: 'Anmelden',
    submitting: 'Anmeldung...',
    forgotPassword: 'Passwort vergessen?',
    noAdminRights: 'Sie haben keine Admin-Rechte',
    errorGeneric: 'Bei der Anmeldung ist ein Fehler aufgetreten',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
  },
  auth: {
    optional: 'optional',
  },
  home: {
    title: 'Stimmen Sie bei Live-Konzerten für Ihre Lieblingssongs!',
    wantToVote: 'Ich möchte abstimmen',
    wantToVoteDescription: 'Kostenloses Konto erstellen, um bei Konzerten abzustimmen',
    wantToManageBand: 'Ich manage meine Band',
    wantToManageBandDescription: 'Konto erstellen, um Ihre Events und Songs zu verwalten',
    alreadyHaveAccount: 'Bereits ein Konto?',
  },
  landing: {
    languageLabel: 'Sprache wählen',
    heroTitle: 'Lassen Sie das Publikum den nächsten Song Ihrer Setlist wählen',
    heroSubtitle:
      'Erstellen Sie Ihre Setlist. Fans scannen einen QR-Code und stimmen in Echtzeit für den nächsten Song. Ein einzigartiges Erlebnis bei jedem Auftritt.',
    ctaPrimary: 'Band-Konto erstellen — kostenlos testen',
    whyTitle: 'Warum PlayItNow?',
    benefit1Title: 'Ein QR-Code, das Publikum stimmt ab',
    benefit1Desc: 'Ihr Publikum scannt und stimmt per Handy für Lieblingssongs. Mehr Interaktion.',
    benefit2Title: 'Live-Ranking',
    benefit2Desc: 'Stimmen in Echtzeit. Sie spielen die meistgewünschten Titel auf der Bühne.',
    benefit3Title: 'Einfach für Bands',
    benefit3Desc: 'Events erstellen, Setlist verwalten, Voting per Klick starten. Preise für Künstler.',
    twoWaysTitle: 'Zwei Wege, PlayItNow zu erleben',
    ctaBand: 'Ich bin eine Band',
    ctaBandDesc: 'Events erstellen, Songs hinzufügen, das Publikum live abstimmen lassen.',
    ctaFan: 'Ich bin Zuschauer',
    ctaFanDesc: 'Per QR-Code zu einem Konzert kommen und für die gewünschten Songs abstimmen.',
    alreadyAccount: 'Bereits ein Konto?',
    login: 'Anmelden',
    learnMore: 'Events anzeigen',
  },
  public: {
    login: {
      title: 'PlayItNow',
      subtitle: 'Stimmen Sie für Ihre Lieblingssongs!',
      subtitle2: 'Die gewählten Titel werden live gespielt!',
      identifyTitle: 'Identifizieren Sie sich',
      identifySubtitle: 'Stimmen Sie ab, um den nächsten Song des Konzerts zu wählen!',
      emailLabel: 'E-Mail oder Benutzername',
      emailPlaceholder: 'ihre@email.com oder Benutzername',
      passwordLabel: 'Passwort',
      passwordPlaceholder: '••••••••',
      submitButton: 'Anmelden',
      submitting: 'Anmeldung...',
      loading: 'Laden...',
      withoutRegistration: 'Zum Voting',
      or: 'ODER',
      errorGeneric: 'Ein Fehler ist aufgetreten',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort verbergen',
      firstNameLabel: 'Ihr Vorname (optional)',
      firstNamePlaceholder: 'Max',
      firstNameHint: 'Ihr Vorname wird bei Ihren Abstimmungen angezeigt',
      haveAccount: 'Ich habe ein Konto',
      forgotPassword: 'Passwort vergessen?',
      createAccount: 'Konto erstellen (kostenlos)',
      pinDataHub: 'Ich verwalte meine Band',
      orDivider: 'oder',
      loginWithGoogle: 'Mit Google anmelden',
      loginWithFacebook: 'Mit Facebook anmelden',
      oauthNoAccount: 'Kein Konto mit diesem Profil verknüpft. Wählen Sie auf der Startseite « Fan-Konto » oder « Band-Konto » und fahren Sie mit Google oder Facebook fort.',
      oauthFailed: 'Anmeldung mit diesem Anbieter fehlgeschlagen. Bitte erneut versuchen.',
      oauthNoEmail: 'Facebook hat keine E-Mail-Adresse bereitgestellt. Prüfen Sie die Berechtigungen oder registrieren Sie sich mit Google.',
      oauthUnavailable: 'Anmeldung mit diesem Anbieter ist vorübergehend nicht verfügbar.',
      oauthUseProvider: 'Mit Google oder Facebook anmelden.',
      oauthCompleteEmailTitle: 'Facebook hat Ihre E-Mail nicht geteilt',
      oauthCompleteEmailDescription: 'Geben Sie Ihre E-Mail-Adresse ein, um die Anmeldung abzuschließen.',
      oauthCompleteEmailSubmit: 'Anmeldung abschließen',
      oauthCompleteEmailPlaceholder: 'ihre@email.com',
      oauthCompleteEmailExpired: 'Sitzung abgelaufen. Melden Sie sich erneut mit Facebook an.',
      oauthCompleteEmailNoAccount: 'Wählen Sie zuerst einen Kontotyp (Fan oder Band) auf der Startseite.',
    },
    register: {
      title: 'Konto erstellen',
      subtitle: 'Werden Sie Teil der PlayItNow-Community',
      firstNameLabel: 'Vorname',
      firstNamePlaceholder: 'Max',
      lastNameLabel: 'Nachname',
      lastNamePlaceholder: 'Mustermann',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre@email.com',
      usernameLabel: 'Benutzername',
      usernamePlaceholder: 'max.mustermann',
      autoGenerated: 'Automatisch generiert',
      usernameHint: 'Sie können diesen Benutzernamen anpassen',
      submitButton: 'Mein Konto erstellen',
      submitting: 'Konto wird erstellt...',
      backToLogin: 'Zurück zur Anmeldung',
      orDivider: 'oder',
      continueWithGoogle: 'Mit Google fortfahren',
      continueWithFacebook: 'Mit Facebook fortfahren',
      successTitle: 'Registrierung erfolgreich!',
      successMessage:
        'Eine Bestätigungs-E-Mail wurde gesendet. Prüfen Sie Ihren Posteingang, um Ihr Konto zu aktivieren.',
      error: {
        firstNameRequired: 'Vorname ist erforderlich',
        lastNameRequired: 'Nachname ist erforderlich',
        emailRequired: 'E-Mail ist erforderlich',
        generic: 'Beim Erstellen des Kontos ist ein Fehler aufgetreten',
      },
      bandNameLabel: 'Bandname',
      bandNamePlaceholder: 'Name Ihrer Band',
      passwordLabel: 'Passwort',
      passwordPlaceholder: '••••••••',
      passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen haben',
      logoUrlLabel: 'Logo-URL (optional)',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort verbergen',
    },
    events: {
      title: 'Kommende Veranstaltungen',
      noEvents: 'Keine kommenden Veranstaltungen',
      noEventsDescription: 'In den nächsten 2 Tagen sind keine Veranstaltungen geplant.',
      errorLoad: 'Fehler beim Laden der Veranstaltungen',
      settings: 'Einstellungen',
      logout: 'Abmelden',
    },
    event: {
      invalidSlug: 'Ungültiger Veranstaltungs-Slug',
      notFound: 'Veranstaltung nicht gefunden',
      errorLoad: 'Fehler beim Laden der Veranstaltung',
      backToEvents: 'Zurück zu den Veranstaltungen',
      songsTitle: 'Verfügbare Songs',
      noSongs: 'Derzeit keine Songs verfügbar',
      vote: 'Abstimmung',
      voted: 'Abgestimmt',
      loading: 'Laden...',
      votesRemaining: 'Verbleibende Stimmen',
      voteSuccess: 'Ihre Stimme wurde gezählt!',
      voteError: 'Fehler beim Speichern Ihrer Stimme',
      totalVotes: 'Stimmen gesamt',
      votesLabel: 'Stimmen',
      blindVoteMessage: 'Das Ranking wird von der Band bekannt gegeben.',
      rankingTitle: 'Ranking',
      votingPaused: 'Die Abstimmung ist derzeit ausgesetzt.',
      votingCompleted: 'Diese Veranstaltung ist beendet. Die Abstimmung ist geschlossen.',
      settings: 'Einstellungen',
      logout: 'Abmelden',
    },
    qrCode: {
      title: 'Veranstaltung teilen',
      description: 'Scannen Sie diesen QR-Code oder teilen Sie den Link, um andere zum Abstimmen einzuladen',
      share: 'Teilen',
      copy: 'Link kopieren',
      show: 'QR-Code anzeigen',
      shareText: 'Stimmen Sie mit mir über die Songs von {{eventName}} ab!',
    },
    settings: {
      title: 'Kontoeinstellungen',
      account: 'Konto',
      email: 'E-Mail',
      username: 'Benutzername',
      firstName: 'Vorname',
      lastName: 'Nachname',
      save: 'Speichern',
      saving: 'Speichern...',
      success: 'Einstellungen erfolgreich gespeichert',
      error: 'Fehler beim Speichern',
      password: {
        title: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Neues Passwort',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Neues Passwort bestätigen',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Passwort ändern',
        changing: 'Wird geändert...',
        success: 'Passwort erfolgreich geändert. Bitte melden Sie sich erneut an.',
        error: 'Fehler beim Ändern des Passworts',
        mismatch: 'Die Passwörter stimmen nicht überein',
        incorrect: 'Das aktuelle Passwort ist falsch',
      },
      deleteAccount: {
        title: 'Konto löschen',
        description: 'Das Löschen Ihres Kontos ist endgültig und kann nicht rückgängig gemacht werden.',
        button: 'Mein Konto löschen',
        confirming: 'Bestätigung...',
        confirmTitle: 'Löschung bestätigen',
        confirmMessage:
          'Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion ist unwiderruflich.',
        confirmButton: 'Ja, löschen',
        cancelButton: 'Abbrechen',
        success: 'Konto erfolgreich gelöscht',
        error: 'Fehler beim Löschen des Kontos',
      },
    },
    dataExport: {
      title: 'Ihre Daten exportieren',
      description:
        'Gemäß DSGVO können Sie den Export aller Ihrer auf PlayItNow gespeicherten personenbezogenen Daten anfordern.',
      whatIncluded: 'Der Export umfasst:',
      included: {
        profile: 'Ihre Profilinformationen (E-Mail, Name, Vorname usw.)',
        votes: 'Ihre Abstimmungshistorie',
        preferences: 'Ihre Einstellungen (Design, Sprache)',
        sessions: 'Ihre Anmeldesitzungen',
      },
      exportButton: 'Meine Daten exportieren',
      exporting: 'Export wird durchgeführt...',
      success: 'Ihre Daten wurden erfolgreich exportiert. Der Download beginnt in Kürze.',
      error: 'Beim Export Ihrer Daten ist ein Fehler aufgetreten.',
      note: 'Hinweis: Der Export kann einen Moment dauern. Die Datei wird im JSON-Format bereitgestellt.',
    },
  },
  legal: {
    title: 'Impressum',
    editor: {
      title: 'Herausgeber',
      name: 'axialdata',
      email: 'E-Mail: contact@axialdata.net',
      siret: 'SIRET: 49347625300023',
    },
    publication: {
      title: 'Verantwortlicher Redakteur',
      director: 'Pierre-Yves Léglise',
    },
    hosting: {
      title: 'Hosting',
      name: 'Hostinger International Ltd',
      addressLine1: 'Die Anwendung wird in Frankreich gehostet (Rechenzentrum Paris).',
      addressLine2: 'Firmensitz: Švitrigailos g. 34, LT-03230 Vilnius, Litauen',
      country: 'Litauen',
      url: 'https://www.hostinger.com',
    },
    dataProtection: {
      title: 'Datenschutz',
      description:
        'Gemäß der Datenschutz-Grundverordnung (DSGVO) haben Sie Rechte in Bezug auf Ihre personenbezogenen Daten.',
      link: 'Datenschutzerklärung anzeigen',
    },
  },
  privacy: {
    title: 'Datenschutzerklärung',
    lastUpdated: 'Letzte Aktualisierung: Oktober 2025',
    intro: {
      title: 'Einführung',
      description:
        'PlayItNow verpflichtet sich, Ihre Privatsphäre und personenbezogenen Daten zu schützen. Diese Richtlinie erläutert, wie wir Ihre Informationen erfassen, nutzen und schützen.',
    },
    dataCollection: {
      title: 'Erhobene Daten',
      bands: {
        title: 'Für Bands (zahlende Kunden)',
        email: 'E-Mail-Adresse',
        username: 'Benutzername',
        name: 'Bandname und Kontaktdaten',
        payment: 'Zahlungsinformationen (über sicheren Drittanbieter)',
        logo: 'Band-Logo',
      },
      spectators: {
        title: 'Für Zuschauer (kostenlose Nutzer)',
        email: 'E-Mail-Adresse (bei Kontoerstellung)',
        firstName: 'Vorname (optional, für Anzeige bei Abstimmungen)',
        fingerprint: 'Browser-Fingerabdruck (Betrugsprävention)',
        ip: 'IP-Adresse (für Sicherheit und Prüfung)',
        votes: 'Abstimmungshistorie',
      },
    },
    purposes: {
      title: 'Verarbeitungszwecke',
      authentication: 'Authentifizierung und Kontoverwaltung',
      voting: 'Verwaltung des interaktiven Abstimmungssystems',
      fraud: 'Betrugsprävention und Abstimmungssicherheit',
      billing: 'Abrechnung und Abonnementverwaltung (nur Bands)',
      support: 'Kundensupport und technische Hilfe',
      preferences: 'Speicherung Ihrer Einstellungen (Design, Sprache)',
      analytics: 'Messung der Seitenbesuche (eigener Rybbit-Server, nur intern: Aufrufe, Herkunft; keine Weitergabe oder Verkauf von Daten)',
    },
    legalBasis: {
      title: 'Rechtsgrundlage',
      description:
        'Die Verarbeitung Ihrer Daten basiert auf: (1) Vertragserfüllung für Bands, (2) Ihrer Einwilligung für Zuschauer, (3) unserem berechtigten Interesse an Sicherheit und Betrugsprävention.',
    },
    retention: {
      title: 'Aufbewahrungsdauer',
      active: 'Aktive Kontodaten: für die Dauer der Nutzung des Dienstes gespeichert',
      inactive: 'Inaktive Kontodaten: nach 3 Jahren Inaktivität gelöscht',
      legal: 'Für gesetzliche Verpflichtungen erforderliche Daten: gemäß den geltenden Fristen aufbewahrt',
    },
    rights: {
      title: 'Ihre Rechte',
      description: 'Gemäß DSGVO stehen Ihnen folgende Rechte zu:',
      access: 'Auskunftsrecht: Ihre personenbezogenen Daten einsehen',
      rectification: 'Berichtigungsrecht: unrichtige Daten korrigieren',
      deletion: 'Recht auf Löschung: Ihre Daten löschen (Recht auf Vergessenwerden)',
      portability: 'Datenübertragbarkeit: Ihre Daten in einem strukturierten Format erhalten',
      opposition: 'Widerspruchsrecht: der Verarbeitung Ihrer Daten widersprechen',
      limitation: 'Recht auf Einschränkung: die Verarbeitung Ihrer Daten einschränken',
      contact:
        'Zur Ausübung Ihrer Rechte kontaktieren Sie uns unter: contact@axialdata.net. Sie können Ihre Daten auch unter Kontoeinstellungen exportieren oder löschen.',
    },
    security: {
      title: 'Datensicherheit',
      description:
        'Wir setzen geeignete technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Verlust, Zerstörung oder Veränderung zu schützen. Daten werden auf sicheren Servern gespeichert und die Kommunikation ist verschlüsselt.',
    },
    cookies: {
      title: 'Cookies und Tracker',
      description:
        'Unsere Anwendung verwendet für den Betrieb des Dienstes notwendige Cookies. Weitere Informationen finden Sie in unserer Cookie-Richtlinie.',
      link: 'Cookie-Richtlinie',
    },
    contact: {
      title: 'Kontakt',
      description: 'Bei Fragen zu dieser Richtlinie oder Ihren personenbezogenen Daten:',
      email: 'contact@axialdata.net',
    },
  },
  cookies: {
    title: 'Cookie-Richtlinie',
    intro: {
      title: 'Einführung',
      description:
        'Diese Seite informiert Sie über die Verwendung von Cookies und ähnlichen Technologien auf PlayItNow.',
    },
    essential: {
      title: 'Notwendige Cookies',
      description:
        'Die folgenden Cookies sind für den Betrieb des Dienstes unbedingt erforderlich und erfordern keine vorherige Einwilligung:',
      accessToken: {
        title: 'access_token',
        description:
          'Authentifizierungs-Cookie zur Aufrechterhaltung Ihrer Sitzung. Dieses Cookie ist httpOnly (nicht per JavaScript zugreifbar) und sicher.',
        duration: 'Dauer: 15 Minuten',
      },
      refreshToken: {
        title: 'refresh_token',
        description:
          'Cookie zur automatischen Verlängerung Ihrer Sitzung. Dieses Cookie ist httpOnly und sicher.',
        duration: 'Dauer: 7 Tage',
      },
      csrfToken: {
        title: 'csrf_token',
        description:
          'Cookie zum Schutz vor CSRF-Angriffen. Dieses Cookie ist per JavaScript für die clientseitige Validierung zugreifbar.',
        duration: 'Dauer: 7 Tage',
      },
    },
    localStorage: {
      title: 'Lokaler Speicher (localStorage)',
      description: 'Wir nutzen auch den lokalen Speicher Ihres Browsers für Ihre Einstellungen:',
      theme: 'Anzeigedesign (Hell-/Dunkelmodus)',
      lang: 'Bevorzugte Sprache',
      firstname: 'Vorname (für Anzeige bei Abstimmungen)',
      fingerprint: 'Browser-Fingerabdruck (Betrugsprävention)',
    },
    analytics: {
      title: 'Reichweitenmessung (Rybbit)',
      description:
        'Wenn die Reichweitenmessung aktiviert ist (Produktion), sendet ein Rybbit-Skript auf unseren Servern (analytics.axialdata.app) minimale Daten (Seitenaufrufe, Herkunft) zur Auswertung der Nutzung, nur intern. Keine Werbung, kein Verkauf oder Weitergabe von Daten. Diese Verarbeitung beruht auf unserem berechtigten Interesse. Rybbit kann einen technischen Bezeichner (Cookie oder lokaler Speicher) zur Deduplizierung von Besuchen verwenden. Sie können Drittanbieter-Skripte in Ihrem Browser blockieren, um diese Erfassung zu deaktivieren.',
    },
    management: {
      title: 'Cookie-Verwaltung',
      description:
        'Sie können Cookies in den Einstellungen Ihres Browsers verwalten. Das Deaktivieren notwendiger Cookies kann die Funktionsfähigkeit der Anwendung beeinträchtigen.',
    },
  },
  terms: {
    title: 'Allgemeine Geschäftsbedingungen',
    lastUpdated: 'Letzte Aktualisierung: Oktober 2025',
    intro: {
      title: 'Artikel 1 - Gegenstand',
      description:
        'Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung des PlayItNow-Dienstes, einer SaaS-Plattform, die Musikbands ermöglicht, ihrem Publikum bei Konzerten ein interaktives Erlebnis zu bieten. Diese AGB gelten sowohl für Bands (zahlende Kunden) als auch für Zuschauer (kostenlose Nutzer).',
    },
    service: {
      title: 'Artikel 2 - Beschreibung des Dienstes',
      description:
        'PlayItNow ist eine Webanwendung, mit der Musikbands Veranstaltungen erstellen, eine Song-Bibliothek verwalten und das Publikum abstimmen lassen können. Der Dienst ist für Bands kostenpflichtig und für Zuschauer kostenlos.',
    },
    forBands: {
      title: 'Artikel 3 - Besondere Bedingungen für Bands',
      subtitle: 'Die folgenden Bedingungen gelten nur für Bands, die den Dienst als zahlende Kunden nutzen:',
      registration: {
        title: '3.1 - Registrierung und Konto',
        description:
          'Um den Dienst als Band zu nutzen, müssen Sie ein Konto mit korrekten und aktuellen Angaben erstellen. Sie sind für die Vertraulichkeit Ihrer Zugangsdaten und alle über Ihr Konto durchgeführten Aktivitäten verantwortlich.',
      },
      subscription: {
        title: '3.2 - Abonnements und Preise',
        description:
          'Der Zugang zum Dienst für Bands unterliegt einem kostenpflichtigen Abonnement. Preise, Tarife und Abonnementbedingungen sind auf der Plattform einsehbar. Abonnements werden automatisch verlängert, sofern Sie nicht kündigen.',
      },
      payment: {
        title: '3.3 - Zahlung',
        description:
          'Zahlungen erfolgen über einen sicheren Zahlungsanbieter. Bei Zahlungsausfall kann der Zugang zum Dienst eingeschränkt werden. Bei vorzeitiger Kündigung besteht kein Anspruch auf Rückerstattung, soweit gesetzlich nicht anders vorgesehen.',
      },
      obligations: {
        title: '3.4 - Pflichten',
        customer: {
          title: '3.4.1 - Pflichten des Kunden',
          accuracy: 'Korrekte und aktuelle Angaben machen',
          security: 'Vertraulichkeit Ihrer Zugangsdaten wahren',
          compliance: 'Anwendbare Gesetze und Vorschriften einhalten',
          prohibited: 'Den Dienst nicht für illegale oder betrügerische Zwecke nutzen',
        },
        provider: {
          title: '3.4.2 - Pflichten des Anbieters',
          availability: 'Die Verfügbarkeit des Dienstes bestmöglich gewährleisten',
          support: 'Technischen Support im Rahmen des Dienstes leisten',
          security: 'Angemessene Sicherheitsmaßnahmen umsetzen',
        },
      },
      intellectualProperty: {
        title: '3.5 - Geistiges Eigentum',
        description:
          'Alle Bestandteile des PlayItNow-Dienstes (Code, Design, Marken usw.) sind ausschließliches Eigentum von axialdata. Die Nutzung des Dienstes gewährt keine Eigentumsrechte an diesen Bestandteilen.',
      },
      termination: {
        title: '3.6 - Kündigung',
        description:
          'Sie können Ihr Abonnement jederzeit in Ihrem Kundenbereich kündigen. axialdata behält sich vor, bei Verstoß gegen diese AGB Konten zu sperren oder zu kündigen.',
      },
      jurisdiction: {
        title: '3.7 - Anwendbares Recht und Gerichtsstand',
        description:
          'Diese AGB unterliegen französischem Recht. Bei Streitigkeiten sind ausschließlich die französischen Gerichte zuständig.',
      },
    },
    forSpectators: {
      title: 'Artikel 4 - Bedingungen für Zuschauer',
      subtitle: 'Die folgenden Bedingungen gelten nur für Zuschauer, die den Dienst kostenlos nutzen:',
      voting: {
        title: '4.1 - Abstimmungssystem',
        description: 'Bei der Teilnahme an einer Veranstaltung können Sie:',
        rules: {
          one: 'Gemäß den von der Band festgelegten Regeln für einen oder mehrere Songs abstimmen',
          fraud: 'Abstimmungslimits einhalten, um Betrug zu vermeiden',
          respect: 'Den Dienst respektvoll und bestimmungsgemäß nutzen',
        },
      },
      account: {
        title: '4.2 - Benutzerkonto',
        description:
          'Die Erstellung eines Kontos ist optional. Sie können anonym teilnehmen, indem Sie nur einen Vornamen angeben. Bei Kontoerstellung sind Sie für die Vertraulichkeit Ihrer Zugangsdaten verantwortlich.',
      },
      conduct: {
        title: '4.3 - Verhaltensregeln',
        description: 'Es ist strikt untersagt:',
        prohibited: {
          fraud: 'Das Abstimmungssystem zu manipulieren',
          abuse: 'Den Dienst missbräuchlich oder böswillig zu nutzen',
          illegal: 'Den Dienst für illegale Zwecke zu nutzen',
        },
      },
      privacy: {
        title: '4.4 - Personenbezogene Daten',
        description:
          'Die Verarbeitung Ihrer personenbezogenen Daten unterliegt unserer Datenschutzerklärung. Mit der Nutzung des Dienstes akzeptieren Sie diese Richtlinie.',
        link: 'Datenschutzerklärung anzeigen',
      },
    },
    liability: {
      title: 'Artikel 5 - Haftung',
      description:
        'axialdata haftet nicht für direkte oder indirekte Schäden aus der Nutzung oder der Unmöglichkeit der Nutzung des Dienstes. Für Bands ist die Haftung auf den Betrag der für das Abonnement gezahlten Summen beschränkt. Für Zuschauer wird der Dienst „wie besehen“ ohne Gewährleistung bereitgestellt.',
    },
    modifications: {
      title: 'Artikel 6 - Änderungen',
      description:
        'axialdata behält sich vor, diese AGB jederzeit zu ändern. Änderungen treten mit der Veröffentlichung in Kraft. Ihre fortgesetzte Nutzung des Dienstes gilt als Akzeptanz der neuen Bedingungen.',
    },
    contact: {
      title: 'Artikel 7 - Kontakt',
      description: 'Bei Fragen zu diesen AGB:',
      email: 'contact@axialdata.net',
    },
  },
  cookieBanner: {
    message:
      'Diese Seite verwendet notwendige Cookies und Reichweitenmessung (anonym, nur intern). Mit dem weiteren Surfen akzeptieren Sie deren Verwendung.',
    learnMore: 'Mehr zu Cookies',
    accept: 'Akzeptieren',
  },
  footer: {
    legal: 'Impressum',
    privacy: 'Datenschutz',
    cookies: 'Cookies',
    terms: 'AGB',
  },
  errors: {
    EVENT_NOT_AVAILABLE_YET:
      'Diese Veranstaltung ist noch nicht verfügbar. Kommen Sie zum geplanten Datum und zur geplanten Uhrzeit zurück, um abzustimmen.',
    networkError:
      'Der Server ist nicht erreichbar. Überprüfen Sie Ihre Verbindung oder versuchen Sie es später erneut.',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    validationError: 'Ungültige Daten. Bitte überprüfen Sie das Formular.',
    badRequest: 'Ungültige Anfrage.',
    unauthorized: 'Authentifizierung erforderlich.',
    forbidden: 'Zugriff verweigert.',
    notFound: 'Ressource nicht gefunden.',
    invalidJsonBody: 'Ungültiges Datenformat.',
    invalidCredentials: 'Ungültige Anmeldedaten.',
    emailAlreadyRegistered: 'Diese E-Mail-Adresse ist bereits registriert.',
    notAuthenticated: 'Sie müssen angemeldet sein.',
    tokenRequired: 'Link ungültig oder abgelaufen.',
    ONE_SHOW_DATE_OUT_OF_RANGE:
      'Das ONE_SHOW-Event-Datum muss zwischen Kaufdatum und +30 Tagen liegen',
  },
  common: {
    copyright: 'Alle Rechte vorbehalten',
    year: new Date().getFullYear().toString(),
    company: 'axialdata',
    required: 'Pflichtfeld',
    back: 'Zurück',
    goHome: 'Zur Startseite',
    close: 'Schließen',
    cancel: 'Abbrechen',
    selectLanguage: 'Sprache wählen',
    skipToContent: 'Zum Hauptinhalt',
    activateDarkMode: 'Dunkelmodus aktivieren',
    activateLightMode: 'Hellmodus aktivieren',
    loading: 'Laden...',
    processing: 'Verarbeitung...',
    logoUrlExpiringModalTitle: 'Bild-URL kann ablaufen',
    logoUrlExpiringModalMessage:
      'Diese URL verweist auf einen Host (z. B. Facebook), dessen Bildlinks mit der Zeit ungültig werden können. Das Bild wird möglicherweise später nicht mehr angezeigt. Sie können diese URL bei Bedarf trotzdem speichern.',
    ok: 'OK',
  },
  pwa: {
    install: {
      button: 'App installieren',
      installButton: 'Installieren',
      promptDescription: 'Installieren Sie PlayItNow auf Ihrem Gerät für ein besseres Erlebnis',
      waiting: 'Warten auf Installationserlaubnis...',
      iosButton: 'Auf iOS installieren',
      iosTitle: 'PlayItNow auf iPhone/iPad installieren',
      iosStep1: '1. Tippen Sie auf die Teilen-Schaltfläche unten auf dem Bildschirm',
      iosStep2: '2. Scrollen Sie nach unten und wählen Sie „Zum Home-Bildschirm“',
      iosStep3: '3. Tippen Sie auf „Hinzufügen“, um die App zu installieren',
    },
  },
  forgotPassword: {
    title: 'Passwort vergessen',
    subtitle: 'Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'ihre@email.com',
    submitButton: 'Link zum Zurücksetzen senden',
    submitting: 'Wird gesendet...',
    successMessage: 'Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.',
    backToLogin: 'Zurück zur Anmeldung',
    errorGeneric: 'Ein Fehler ist aufgetreten',
  },
  resetPassword: {
    title: 'Passwort zurücksetzen',
    subtitle: 'Geben Sie Ihr neues Passwort ein',
    passwordLabel: 'Neues Passwort',
    passwordPlaceholder: '••••••••',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: '••••••••',
    submitButton: 'Passwort zurücksetzen',
    submitting: 'Wird zurückgesetzt...',
    successMessage: 'Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt anmelden.',
    passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
    backToLogin: 'Zurück zur Anmeldung',
    errorGeneric: 'Beim Zurücksetzen ist ein Fehler aufgetreten',
    invalidToken: 'Der Link zum Zurücksetzen ist ungültig oder abgelaufen',
  },
  confirmEmail: {
    title: 'Bestätigen Sie Ihre E-Mail-Adresse',
    setPasswordTitle: 'Passwort festlegen',
    setPasswordSubtitle: 'Wählen Sie ein Passwort, um Ihre Registrierung abzuschließen.',
    passwordLabel: 'Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    submitButton: 'Mein Konto aktivieren',
    confirming: 'Wird bestätigt…',
    successFan: 'Konto aktiviert. Weiterleitung…',
    successBand: 'Konto erstellt. Weiterleitung…',
    alreadyCompleted: 'Registrierung bereits abgeschlossen oder Link abgelaufen. Bitte melden Sie sich an.',
    goToLogin: 'Zur Anmeldung',
    invalidToken: 'Link ungültig oder abgelaufen. Bitte erneut registrieren oder eine neue E-Mail anfordern.',
    missingToken: 'Bestätigungslink fehlt.',
    errorGeneric: 'Ein Fehler ist aufgetreten.',
    backToRegister: 'Zurück zur Registrierung',
  },
  admin: {
    nav: {
      dashboard: 'Dashboard',
      events: 'Veranstaltungen',
      songs: 'Songs',
      venues: 'Spielstätten',
      members: 'Mitglieder',
      settings: 'Einstellungen',
      userSettings: 'Mein Konto',
      logout: 'Abmelden',
    },
    dashboard: {
      welcome: 'Willkommen',
      bandName: 'Band',
      superadminMode: 'Super-Admin-Modus',
      totalEvents: 'Veranstaltungen gesamt',
      activeEvents: 'Aktive Veranstaltungen',
      upcomingEvents: 'Kommende Veranstaltungen',
      quickActions: 'Schnellaktionen',
      createEvent: 'Veranstaltung erstellen',
      manageVenues: 'Spielstätten verwalten',
      recentEvents: 'Letzte Veranstaltungen',
      viewAll: 'Alle anzeigen',
      noEvents: 'Noch keine Veranstaltungen',
      createFirstEvent: 'Erstellen Sie Ihre erste Veranstaltung',
      noVenue: 'Keine Spielstätte',
      errorLoad: 'Fehler beim Laden der Daten',
      status: {
        pending: 'Ausstehend',
        active: 'Aktiv',
        completed: 'Abgeschlossen',
      },
    },
    planBadge: {
      tooltip: 'Aktueller Tarif — Klicken Sie, um Ihr Abonnement zu verwalten',
      ariaLabel: 'Abonnement anzeigen und verwalten',
    },
    oneShowAlert: {
      title: 'Gültigkeit des OneShow-Events',
      daysRemaining: 'Noch {{days}} Tag(e)',
      daysShort: '{{days}}T',
      daysRemainingMessage: 'Sie haben noch {{days}} Tag(e), um diese Veranstaltung im unbegrenzten Modus zu nutzen.',
      urgentTitle: 'Ablauf demnächst',
      expired: 'OneShow-Event abgelaufen',
      expiredShort: 'Abgelaufen',
      expiredMessage:
        'Diese Veranstaltung hat das Ende ihrer Gültigkeitsdauer erreicht. Wechseln Sie zu ProGig für unbegrenzte Veranstaltungen.',
      upgradeCta: 'Tarife anzeigen',
    },
    subscription: {
      plan: {
        FREE: 'Kostenlos',
        PRO_GIG: 'ProGig',
        LIVE_TOUR: 'LiveTour',
        ONE_SHOW: 'OneShow',
      },
      title: 'Abonnement',
      subtitle: 'Verwalten Sie Ihren Band-Tarif und Nutzungslimits',
      currentPlan: 'Aktueller Tarif',
      currentPlanFree: 'Kostenlos (FREE)',
      currentPlanProGig: 'ProGig',
      currentPlanLiveTour: 'LiveTour',
      freeDescription: 'Ideal zum Kennenlernen und Ausprobieren des Dienstes.',
      proGigDescription: 'Tarif für Bands mit mehreren Auftritten pro Monat.',
      liveTourDescription: 'Tarif für intensive Tourneen und unbegrenzte Nutzung.',
      chooseProGig: 'Zu ProGig wechseln',
      chooseLiveTour: 'Zu LiveTour wechseln',
      loading: 'Abonnement wird geladen...',
      errorLoad: 'Beim Laden Ihres Abonnements ist ein Fehler aufgetreten.',
      errorCheckout:
        'Fehler beim Erstellen der Stripe-Zahlungssitzung. Bitte versuchen Sie es in Kürze erneut.',
      successTitle: 'Zahlung erfolgreich',
      successMessage: 'Ihre Zahlung wurde verarbeitet. Ihr Abonnement wird in Kürze aktualisiert.',
      successRedirect: 'Sie werden in Kürze zu Ihrem Dashboard weitergeleitet.',
      monthlyQuota: 'Monatskontingent',
      freeQuota: 'Kostenloses Kontingent',
      eventsUsed: '{{current}} / {{limit}} Veranstaltungen',
      billingPeriod: 'Zeitraum: {{start}} – {{end}}',
      quotaReached: 'Monatskontingent erreicht',
      quotaReachedMessage:
        'Sie haben Ihr Veranstaltungslimit für diesen Zeitraum erreicht. Das Kontingent wird am Ende Ihres Abrechnungszeitraums zurückgesetzt.',
      quotaWarning: 'Monatskontingent fast erreicht',
      quotaWarningMessage: 'Sie haben noch {{remaining}} Veranstaltung(en) in diesem Zeitraum.',
      quotaInfo: 'Sie haben noch {{remaining}} Veranstaltung(en) in diesem Zeitraum.',
      upgradePlan: 'Tarif upgraden',
      upgradeToUnlimited: 'Auf unbegrenzt upgraden',
      upgradeSingleEventConfirm: 'Sie sind dabei, die Veranstaltung „{{eventName}}“ auf unbegrenzt zu upgraden.',
      singleEventDescription:
        'Einmalzahlung für unbegrenzte Stimmen für diese spezifische Veranstaltung.',
      oneShowValidity: 'Gültig {{days}} Tage ab Kauf.',
      oneShowNonRefundable:
        'Nicht erstattungsfähige Zahlung: Nach Durchführung kann die Zahlung nicht storniert oder erstattet werden.',
      multipleProGigSuggestion: 'Mehrere Veranstaltungen? Der ProGig-Tarif könnte günstiger sein.',
      comparePlans: 'Tarife vergleichen →',
      upgradeToUnlimitedNow: 'Jetzt auf unbegrenzt upgraden',
      checkoutError: 'Fehler beim Erstellen der Zahlungssitzung. Bitte erneut versuchen.',
      oneShowPrice: 'Preis',
      oneShowPaymentType: 'Einmalzahlung',
      oneShowBenefitsTitle: 'Das erhalten Sie:',
      oneShowBenefitVotes: 'Unbegrenzte Stimmen für diese Veranstaltung',
      oneShowBenefitTime: 'Kein Zeitlimit für die Aktivierung',
      chooseOption: 'Option wählen',
      convertEvent: 'Veranstaltung umwandeln',
      createEvent: 'Veranstaltung erstellen',
      selectFreeEvent: 'Wählen Sie eine kostenlose Veranstaltung zur Umwandlung:',
      convertThisEvent: 'Diese Veranstaltung umwandeln',
      noFreeEventsToConvert: 'Keine kostenlosen Veranstaltungen zum Umwandeln. Erstellen Sie zuerst eine Veranstaltung.',
      createDescription: 'Erstellen Sie eine neue Veranstaltung mit dem One-Show-Tarif.',
      createNewOneShot: 'One-Show-Veranstaltung erstellen',
      createOneShotEventTitle: 'One-Show-Veranstaltung erstellen',
      proceedToPayment: 'Zur Zahlung',
      oneShowDescription: 'Einmalzahlung für eine unbegrenzte Veranstaltung.',
      configureOneShot: 'Konfigurieren',
      convertEventFromUrl: 'Die Veranstaltung „{{name}}“ wird in eine One-Show-Veranstaltung umgewandelt.',
      priceFree: 'Kostenlos',
      priceOneTime: '{{price}}€ (Einmalzahlung)',
      pricePerMonth: '{{price}}€ / Monat',
      currentPlanBadge: 'Aktueller Tarif',
      selectPlan: 'Wählen',
      planFree: 'Kostenlos',
      featureMaxEvents: 'Max. Veranstaltungen',
      featureMaxVotes: 'Stimmen pro Veranstaltung',
      featureActiveTime: 'Kumulierte Aktivierungszeit',
      featureEventsPerMonth: 'Veranstaltungen pro Monat',
      featureOneEvent: '1 Veranstaltung (einzeln)',
      featureValidity: 'Gültigkeit',
      validityDays: '{{days}} Tage',
      unlimited: 'Unbegrenzt',
      events: 'Veranstaltungen',
      votes: 'Stimmen',
      minutes: 'Min',
      planNote: {
        FREE: 'Max. 5 Veranstaltungen (ohne OneShow). 8 Stimmen pro Veranstaltung. 40 Min. kumulierte Aktivierung.',
        ONE_SHOW: 'Einmalzahlung. Eine Veranstaltung unbegrenzt (unbegrenzte Stimmen, kein Zeitlimit).',
        PRO_GIG: '3 Veranstaltungen pro Monat (gleitender Zeitraum basierend auf Stripe-Abrechnung).',
        LIVE_TOUR: 'Unbegrenzte Veranstaltungen. Ideal für Tourneen.',
      },
      cancelSubscriptionButton: 'Abonnement kündigen',
      cancelSubscriptionConfirmTitle: 'Abonnement kündigen',
      cancelSubscriptionConfirmMessage:
        'Keine Erstattung. Ihr Abonnement bleibt bis {{date}} (Ende des bezahlten Zeitraums) aktiv, danach wechseln Sie zurück zum kostenlosen Tarif. Fortfahren?',
      cancelSubscriptionSuccess: 'Abonnement gekündigt. Sie behalten den Zugang bis {{date}}.',
      cancelSubscriptionError: 'Fehler beim Kündigen des Abonnements.',
      accessUntil: 'Zugang bis {{date}}',
      cancellationScheduled: 'Kündigung geplant',
      cancelling: 'Wird gekündigt...',
    },
    events: {
      title: 'Veranstaltungen',
      subtitle: 'Verwalten Sie Ihre Konzerte und Veranstaltungen',
      eventsList: 'Liste der Veranstaltungen',
      upcomingEvents: 'Kommende Veranstaltungen',
      pastEvents: 'Vergangene Veranstaltungen',
      noEvents: 'Noch keine Veranstaltungen',
      addEvent: 'Veranstaltung erstellen',
      add: 'Erstellen',
      adding: 'Wird erstellt...',
      edit: 'Bearbeiten',
      editing: 'Wird bearbeitet...',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      confirmDeleteTitle: 'Veranstaltung löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie die Veranstaltung „{{name}}“ löschen möchten?',
      name: 'Name der Veranstaltung',
      namePlaceholder: 'z. B.: Konzert im Zenith',
      venue: 'Spielstätte',
      selectVenue: 'Spielstätte auswählen',
      date: 'Datum',
      time: 'Uhrzeit',
      oneShowDateRestriction: 'Datum gesperrt: zwischen Kauf und +{{days}} Tagen',
      maxVotesPerUser: 'Max. Stimmen pro Nutzer',
      maxVotes: 'Max. Stimmen',
      tiebreaker: 'Gleichstand',
      tiebreakerChronological: 'Chronologisch (zuerst abgestimmt)',
      tiebreakerRandom: 'Zufällig',
      tiebreakerManual: 'Manuell (Band entscheidet)',
      showRanking: 'Ranking anzeigen',
      showRankingToPublic: 'Ranking für Zuschauer anzeigen',
      blindVote: 'Verdeckte Abstimmung',
      status: {
        pending: 'Ausstehend',
        active: 'Aktiv',
        completed: 'Abgeschlossen',
      },
      planBadge: {
        subscription: 'Abonnement (unbegrenzt)',
        oneShow: 'OneShow (unbegrenzte Veranstaltung)',
      },
      addSuccess: 'Veranstaltung erfolgreich erstellt',
      addError: 'Fehler beim Erstellen der Veranstaltung',
      updateSuccess: 'Veranstaltung erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der Veranstaltung',
      deleteSuccess: 'Veranstaltung erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Veranstaltung',
      errorLoad: 'Fehler beim Laden der Veranstaltungen',
      noVenues: 'Sie müssen mindestens eine Spielstätte anlegen, bevor Sie eine Veranstaltung erstellen',
      qrCodeTitle: 'QR-Code erzeugt',
      qrCodeDescription: 'Nutzen Sie diesen Code, damit Zuschauer abstimmen können',
      copyQRCode: 'QR-Code kopieren',
      qrCodeCopied: 'QR-Code in die Zwischenablage kopiert',
      showQRCode: 'QR-Code anzeigen',
      qrCodePrint: 'Drucken',
      qrCodeShare: 'Teilen',
      qrCodeDownload: 'Herunterladen',
      qrCodeUrl: 'URL der Veranstaltung',
      qrCodeShareText: 'Stimmen Sie mit mir über die Songs von {{eventName}} ab!',
      qrCodePrintTitle: 'QR-Code - PlayItNow',
      qrCodePrintInstructions:
        'Scannen Sie diesen QR-Code, um zur Veranstaltung zu gelangen und für Ihre Lieblingssongs abzustimmen. Die gewählten Songs werden live gespielt!',
      delete: 'Löschen',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      complete: 'Abschließen',
      reactivate: 'Reaktivieren',
      activateSuccess: 'Veranstaltung erfolgreich aktiviert',
      activateError: 'Fehler beim Aktivieren der Veranstaltung',
      deactivateSuccess: 'Veranstaltung erfolgreich deaktiviert',
      deactivateError: 'Fehler beim Deaktivieren der Veranstaltung',
      completeSuccess: 'Veranstaltung erfolgreich abgeschlossen',
      completeError: 'Fehler beim Abschließen der Veranstaltung',
      showRankingBtn: 'Ranking für Zuschauer anzeigen',
      hideRankingBtn: 'Ranking vor Zuschauern verbergen',
      rankingHidden: 'Ranking für Zuschauer verborgen',
      rankingVisible: 'Ranking für Zuschauer sichtbar',
      toggleBlindVoteError: 'Fehler beim Ändern der Sichtbarkeit des Rankings',
      live: {
        title: 'Live-Dashboard',
        loading: 'Laden...',
        errorLoad: 'Fehler beim Laden der Daten',
        errorToggle: 'Fehler beim Ändern der Sichtbarkeit',
        errorMarkPlayed: 'Fehler beim Markieren des Songs',
        eventNotFound: 'Veranstaltung nicht gefunden',
        backToEvents: 'Zurück zu den Veranstaltungen',
        totalVotes: 'Stimmen gesamt',
        uniqueVoters: 'Eindeutige Wähler',
        songsPlayed: 'Gespielte Songs',
        noVotesYet: 'Noch keine Stimmen',
        noVotes: 'Noch keine Stimmen',
        rankingHidden: 'Ranking verborgen',
        rankingVisible: 'Ranking sichtbar',
        markPlayed: 'Als gespielt markieren',
        unmarkPlayed: 'Markierung aufheben',
        autoRefresh: 'Auto-Aktualisierung',
        openLive: 'Live öffnen',
      },
      songs: {
        title: 'Songs der Veranstaltung',
        subtitle: 'Verwalten Sie die zur Abstimmung verfügbaren Songs',
        addSong: 'Song hinzufügen',
        searchExisting: 'Vorhandenen Song suchen',
        searchPlaceholder: 'Nach Titel oder Künstler suchen...',
        noResults: 'Keine Songs gefunden',
        or: 'ODER',
        songTitle: 'Titel',
        titlePlaceholder: 'z. B.: Bohemian Rhapsody',
        artist: 'Künstler',
        artistPlaceholder: 'z. B.: Queen',
        duration: 'Dauer',
        durationPlaceholder: 'z. B.: 5:55',
        year: 'Jahr',
        yearPlaceholder: 'z. B.: 2020',
        add: 'Hinzufügen',
        adding: 'Wird hinzugefügt...',
        remove: 'Entfernen',
        noSongs: 'Keine Songs für diese Veranstaltung',
        addSuccess: 'Song erfolgreich hinzugefügt',
        addError: 'Fehler beim Hinzufügen des Songs',
        createSuccess: 'Song erstellt und erfolgreich hinzugefügt',
        createError: 'Fehler beim Erstellen des Songs',
        removeSuccess: 'Song erfolgreich entfernt',
        removeError: 'Fehler beim Entfernen des Songs',
        errorLoad: 'Fehler beim Laden der Songs',
        copyFromEvent: 'Von anderer Veranstaltung kopieren',
        copyModal: {
          title: 'Songliste kopieren',
          description: 'Wählen Sie eine Veranstaltung, um deren Songliste in diese Veranstaltung zu kopieren.',
          noEvents: 'Keine anderen Veranstaltungen verfügbar',
        },
        copySuccess: 'Songs erfolgreich kopiert',
        copySuccessCount: 'Song(s) hinzugefügt',
        copySkipped: 'bereits vorhanden',
        copyNoSongs: 'Die gewählte Veranstaltung enthält keine Songs',
        copyAllAlreadyAdded: 'Alle Songs dieser Veranstaltung sind bereits vorhanden',
        copyError: 'Fehler beim Kopieren der Songs',
      },
    },
    songs: {
      title: 'Song-Bibliothek',
      subtitle: 'Verwalten Sie Ihr Song-Repertoire',
      songsList: 'Songliste',
      noSongs: 'Noch keine Songs',
      addSong: 'Song hinzufügen',
      add: 'Hinzufügen',
      adding: 'Wird hinzugefügt...',
      edit: 'Bearbeiten',
      editing: 'Wird bearbeitet...',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      confirmDeleteTitle: 'Song löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie „{{title}}" von {{artist}} löschen möchten?',
      songTitle: 'Titel',
      titlePlaceholder: 'z. B.: Bohemian Rhapsody',
      artist: 'Künstler',
      artistPlaceholder: 'z. B.: Queen',
      duration: 'Dauer',
      durationPlaceholder: 'z. B.: 5:55',
      durationFormat: 'Format: MM:SS (z. B.: 3:45)',
      year: 'Jahr',
      yearPlaceholder: 'z. B.: 2020',
      addSuccess: 'Song erfolgreich hinzugefügt',
      addError: 'Fehler beim Hinzufügen des Songs',
      updateSuccess: 'Song erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren des Songs',
      deleteSuccess: 'Song erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Songs',
      errorLoad: 'Fehler beim Laden der Songs',
      delete: 'Löschen',
    },
    settings: {
      title: 'Band-Einstellungen',
      subtitle: 'Verwalten Sie die Informationen Ihrer Band',
      bandName: 'Bandname',
      bandNamePlaceholder: 'Name Ihrer Band',
      logoUrl: 'Logo-URL',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      logoPreview: 'Logo-Vorschau',
      save: 'Speichern',
      saving: 'Speichern...',
      successMessage: 'Einstellungen erfolgreich gespeichert',
      errorLoad: 'Fehler beim Laden der Einstellungen',
      errorSave: 'Fehler beim Speichern der Einstellungen',
    },
    members: {
      title: 'Bandmitglieder',
      subtitle: 'Verwalten Sie Ihre Bandmitglieder',
      membersList: 'Mitgliederliste',
      noMembers: 'Noch keine Mitglieder',
      inviteMember: 'Mitglied einladen',
      invite: 'Einladen',
      inviting: 'Einladung wird gesendet...',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      confirmRemoveTitle: 'Mitglied entfernen',
      confirmToggleOwnerTitle: 'Eigentümerstatus ändern',
      email: 'E-Mail',
      emailPlaceholder: 'mitglied@example.com',
      password: 'Passwort',
      passwordPlaceholder: 'Mindestens 8 Zeichen',
      firstName: 'Vorname',
      firstNamePlaceholder: 'Vorname (optional)',
      lastName: 'Nachname',
      lastNamePlaceholder: 'Nachname (optional)',
      owner: 'Eigentümer',
      invitedBy: 'Eingeladen von',
      remove: 'Entfernen',
      confirmRemove: 'Sind Sie sicher, dass Sie {{email}} aus der Band entfernen möchten?',
      inviteSuccess: 'Mitglied erfolgreich eingeladen',
      inviteError: 'Fehler beim Einladen des Mitglieds',
      removeSuccess: 'Mitglied erfolgreich entfernt',
      removeError: 'Fehler beim Entfernen des Mitglieds',
      errorLoad: 'Fehler beim Laden der Mitglieder',
      promote: 'Zum Eigentümer befördern',
      demote: 'Herabstufen',
      confirmToggleOwner: 'Sind Sie sicher, dass Sie dieses Mitglied {{action}} möchten?',
      promoteSuccess: 'Mitglied erfolgreich zum Eigentümer befördert',
      demoteSuccess: 'Mitglied erfolgreich herabgestuft',
      toggleOwnerError: 'Fehler beim Ändern des Mitgliedsstatus',
    },
    venues: {
      title: 'Spielstätten',
      subtitle: 'Verwalten Sie die Orte, an denen Sie auftreten',
      venuesList: 'Liste der Spielstätten',
      noVenues: 'Noch keine Spielstätten',
      addVenue: 'Spielstätte hinzufügen',
      add: 'Hinzufügen',
      adding: 'Wird hinzugefügt...',
      edit: 'Bearbeiten',
      editing: 'Wird bearbeitet...',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      confirmDeleteTitle: 'Spielstätte löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie die Spielstätte „{{name}}" löschen möchten?',
      name: 'Name der Spielstätte',
      namePlaceholder: 'z. B.: Das Zenith',
      address: 'Adresse',
      addressPlaceholder: 'z. B.: 211 Avenue Jean Jaurès',
      city: 'Stadt',
      cityPlaceholder: 'z. B.: Paris',
      country: 'Land',
      countryPlaceholder: 'z. B.: Deutschland',
      googleMapsUrl: 'Google-Maps-Link',
      googleMapsUrlPlaceholder: 'z. B.: https://maps.google.com/...',
      generateMapsUrl: 'Google-Maps-Link erzeugen',
      generateMapsUrlError: 'Geben Sie mindestens den Namen der Spielstätte oder die Stadt ein, um den Link zu erzeugen.',
      viewOnGoogleMaps: 'In Google Maps anzeigen',
      addSuccess: 'Spielstätte erfolgreich hinzugefügt',
      addError: 'Fehler beim Hinzufügen der Spielstätte',
      updateSuccess: 'Spielstätte erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der Spielstätte',
      deleteSuccess: 'Spielstätte erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Spielstätte',
      errorLoad: 'Fehler beim Laden der Spielstätten',
    },
  },
  notFound: {
    title: 'Seite nicht gefunden',
    subtitle: 'Diese Seite existiert nicht',
    description: 'Die gesuchte Seite wurde möglicherweise verschoben oder gelöscht.',
    quickLinks: 'Schnelllinks',
    goHome: 'Zur Startseite',
    goToLogin: 'Zur Anmeldung',
    helpText: 'Wenn Sie einen Fehler vermuten, kontaktieren Sie bitte den Support.',
  },
}
